import { Context } from '@leverege/plugin';
import { Dialogs } from '@leverege/ui-elements';
import { GlobalState } from '@leverege/ui-redux';
import ConvertLocatorToGateway from '../views/ConvertLocatorToGateway';
const objectTypes = ['locator'];
export default {
  id: 'r4k.locator.ConvertToGateway',
  name: 'Convert Locator To Gateway',
  layout: {
    sort: 'item.zzzzzConvert'
  },
  matches: [{
    use: ['contextMenu', 'mobileActionBar'],
    path: ['location.locators', 'company.locations.locators'],
    objectType: objectTypes
  }, {
    client: 'MapBoxRolloverSelectionPointer',
    use: ['contextMenu', 'mobileActionBar']
  }],
  prepare: async cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    if (delegate.relationship.isItem) {
      return GlobalState.dispatch(delegate.parent().requestCanCreate());
    }
    return GlobalState.dispatch(delegate.requestCanCreate());
  },
  isPrepared: cxt => {
    const {
      clientState,
      clientProps
    } = cxt;
    const delegate = clientProps?.delegate || clientState?.actionsContext?.clientProps?.delegate;
    if (delegate.relationship.isItem) {
      return delegate.parent().canCreate(undefined, undefined, undefined, false) != null;
    }
    return delegate.canCreate(undefined, undefined, undefined, false) != null;
  },
  handles: cxt => {
    const targets = Context.getTarget(cxt);
    if (!targets) {
      return false;
    }
    return objectTypes.includes(targets?.type);
  },
  appearance: ({
    context
  }) => {
    return {
      name: 'Convert To Gateway',
      icon: 'fa fa-exchange'
    };
  },
  perform: async data => {
    const {
      context
    } = data;
    const {
      clientProps
    } = context;
    const targets = Context.getTargets(context);
    const locationId = clientProps.parentItem.data?.data?.location?.id || clientProps.parentItem.data.id;
    const systemId = clientProps.parentItem.data.systemId;
    Dialogs.show({
      component: ConvertLocatorToGateway,
      props: {
        targets,
        dispatch: context.clientProps.dispatch,
        locationId,
        systemId,
        reloadData: context.reloadData || clientProps.reloadData
      }
    });
  }
};